import SelectAssetsCombobox from '@/components/SelectAssetsCombobox';
import SendInputForm from './SendInputForm';
import SendCheckAmountBox from './SendCheckAmountBox';
import SendCheckBtn from './SendCheckBtn';
import * as ViewModel from '@/core/presenter/viewModel';
import SendInputMemo from './SendInputMemo';

interface IProps {
  isWritting: boolean;
  sendAddress: string;
  sendAsset: string;
  trxAsset: ViewModel.IAsset | undefined;
  tokenAsset: ViewModel.IAsset | undefined;
  selectedAsset: ViewModel.IAsset | undefined;
  curculateKrw: string;
  isSendCheckBtnDisabled: boolean;
  defaultMemo: string;
  onChangeMemo: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onClickSendCancelBtn: () => void;
  onPaste: (text: string) => void;
  onChangeSendAddress: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onChangeSelectedAsset: (e: React.SyntheticEvent<HTMLInputElement>) => void;
  onChangeSelectedAssetValue: (assetType: ViewModel.AssetType) => void;
  onClickDeleteBtn: () => void;
  onClickResetAmountBtn: () => void;
  onClickSendCheckBtn: () => void;
  onClickCameraBtn: () => void;
  onKeyPress: (e: React.KeyboardEvent<HTMLInputElement>) => void;
}

const SendViewContent = ({
  isWritting,
  sendAddress,
  sendAsset,
  selectedAsset,
  curculateKrw,
  isSendCheckBtnDisabled,
  defaultMemo,
  onChangeMemo,
  onClickSendCancelBtn,
  onClickSendCheckBtn,
  onChangeSendAddress,
  onChangeSelectedAsset,
  onChangeSelectedAssetValue,
  onClickDeleteBtn,
  onClickResetAmountBtn,
  onPaste,
  onClickCameraBtn,
  onKeyPress,
}: IProps) => {
  return (
    <div className="container-style2">
      <div className="content-trxn_snd">
        <h2>보낼 대상:</h2>
        <SendInputForm
          isWritting={isWritting}
          sendAddress={sendAddress}
          onPaste={onPaste}
          onChangeSendAddress={onChangeSendAddress}
          onClickDeleteBtn={onClickDeleteBtn}
          onClickCameraBtn={onClickCameraBtn}
        />
        <SendInputMemo isWritting={isWritting} defaultMemo={defaultMemo} onChangeMemo={onChangeMemo} />
        <SelectAssetsCombobox
          selectedAsset={selectedAsset}
          isWritting={isWritting}
          onChangeSelectedAssetValue={onChangeSelectedAssetValue}
        />
        <SendCheckAmountBox
          selectedAsset={selectedAsset}
          curculateKrw={curculateKrw}
          isWritting={isWritting}
          sendAsset={sendAsset}
          onChangeSelectedAsset={onChangeSelectedAsset}
          onClickResetAmountBtn={onClickResetAmountBtn}
          onKeyPress={onKeyPress}
        />
        <SendCheckBtn
          isWritting={isWritting}
          isSendCheckBtnDisabled={isSendCheckBtnDisabled}
          onClickSendCheckBtn={onClickSendCheckBtn}
          onClickSendCancelBtn={onClickSendCancelBtn}
        />
      </div>
    </div>
  );
};

export default SendViewContent;
